// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2IrDk","row":"styles_row__2JSWQ","noUnderline":"styles_noUnderline__2L4Lw","infoText":"styles_infoText__3ru4D","arrow":"styles_arrow__Orcfu"};